import { Link } from 'react-router-dom';

interface Props {
  title: string;
  eyebrow?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, eyebrow, moreTo, moreLabel = '查看更多' }: Props) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="flex items-center gap-3">
        <span className="w-1.5 h-7 rounded-full bg-primary-500" />
        <div>
          {eyebrow && <p className="font-label text-[11px] tracking-[0.2em] text-accent-600 uppercase mb-1">{eyebrow}</p>}
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">{title}</h2>
        </div>
      </div>
      {moreTo && (
        <Link to={moreTo} className="flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
          {moreLabel} <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}